import { AGENCY_SHIFT_HISTORIES_FETCH_BEGIN } from './action-types'
import { Query } from './types'

export const fetchAgencyShiftHistory = ({ options }: { options: Query }) => ({
  type: AGENCY_SHIFT_HISTORIES_FETCH_BEGIN,
  payload: options,
})
